import { applyTransaction } from "./actions"

export const offlineBalanceReducer = (state, action) => {
  switch (action.type) {
    case "INITIALIZE_OFFLINE_STATE":
      return {
        ...state,
        offline: action.payload,
      }
    case "UPDATE_OFFLINE_TRANSACTION":
      if (!state.offline) {
        return state
      }
      const newOfflineState = applyTransaction(state.offline, action.payload)
      return {
        ...state,
        offline: newOfflineState,
      }
    case "REMOVE_TRANSACTION_FROM_OFFLINE_STATE":
      if (!state.offline) {
        return state
      }
      // To "remove" a transaction, we apply the inverse of it
      const reversedPayload = { ...action.payload, amount: -action.payload.amount }
      const revertedState = applyTransaction(state.offline, reversedPayload)
      return {
        ...state,
        offline: revertedState,
      }
    // case "RESOLVE_OFFLINE_MEMBER_ID":
    //   const { tempId, finalId } = action.payload
    //   if (!state.offline || !state.offline.members[tempId]) {
    //     return state // Nothing to resolve
    //   }
    //   const resolvedState = JSON.parse(JSON.stringify(state))
    //   const memberAccount = resolvedState.offline.members[tempId]
    //   resolvedState.offline.members[finalId] = memberAccount
    //   delete resolvedState.offline.members[tempId]
    //   return resolvedState
    case "CLEAR_OFFLINE_BALANCE":
      return {
        ...state,
        offline: null,
      }
    case "SET_NONE_REVERSED_MEMBER_TRANSACTIONS":
      return {
        ...state,
        online: {
          ...state.online,
          transactions: {
            ...state.online.transactions,
            ...action.payload,
          },
        },
      }

    default:
      return state
  }
}
